import useSWR from 'swr'

import fetcher from 'utils/fetcher'

const useDocumentReprints = (documentId) => {
  const { data, isValidating, mutate } = useSWR(
    documentId ? `/documents/${documentId}/reprints` : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    reprints: data?._embedded?.reprints || [],
    loading: (!data?._embedded?.reprints && !data?.error) || isValidating,
    validating: isValidating,
    count: data?.count,
    total: data?.total,
    totalPages: data?.total_pages,
    pageSize: data?.page_size,
    paginates: data?.paginates,
    error: data?.error,
    mutate,
  }
}

export default useDocumentReprints
